module.exports = __webpack_public_path__ + "static/media/sg6tj0.c70acb60.png";